import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from '../../ui';
import { clean } from '../../../actions';
import warning from '../../../assets/common/warning.png';
import ErrorMessageWrapper from './ErrorMessage.style';

class ErrorMessage extends Component {

  render() {
    const {
      errorText,
      tryAgain,
      tryAgainText,
      tryAgainAction
    } = this.props;

    return (
      <ErrorMessageWrapper>
        <div className="ErrorMessage-container">
          <div className="ErrorMessage-container-image">
            <img className="ErrorMessage-image" src={warning} alt="warning" />
          </div>
          <p className="ErrorMessage-text"> {errorText} </p>
          {tryAgain &&
          <div className="ErrorMessage-button-container">
            <Button onClick={() => {tryAgainAction()}}> {tryAgainText} </Button>
          </div>}
        </div>
      </ErrorMessageWrapper>
    );
  }
}

ErrorMessage.defaultProps = {
  errorText: 'Tuvimos un inconveniente',
  tryAgain: true,
  tryAgainText: 'Volver a intentar',
  tryAgainAction: () => {},
};

export default connect(null, null)(ErrorMessage);